import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "form__control" };
const _hoisted_2 = {
    key: 0,
    class: "file"
};
const _hoisted_3 = ["id", "disabled", "accept", "required", "multiple"];
const _hoisted_4 = {
    key: 3,
    class: "error"
};
import { computed, ref } from "vue";
import palomaFiles from "../../services/PalomaFiles";
import FileLink from "../FileLink.vue";
import Icon from "../Icon.vue";
import Spinner from "../Spinner.vue";
import ProgressBar from "../ProgressBar.vue";
import log from "../../services/Logger";
import { useFieldControl } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlFile',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlFile');
        const root = ref(null);
        const loading = ref(false);
        const progress = ref(0);
        const error = ref(null);
        const showFileLink = computed(() => !!props.data && (typeof props.data === 'string'));
        const acceptedFiles = computed(() => fieldOptions.value.acceptedFiles?.join(',') || undefined);
        function onChange() {
            const files = root.value?.files;
            const bucket = fieldOptions.value.storageLocation;
            if (!bucket) {
                // behave like a normal file input
                emitChange(files);
                return;
            }
            // upload to Paloma files bucket
            if (!files || files.length === 0) {
                emitChange(null);
                return;
            }
            if (files.length > 1) {
                throw 'Multiple files are currently not supported';
            }
            loading.value = true;
            error.value = null;
            palomaFiles
                .upload(bucket, files[0], progressEvent => {
                progress.value = progressEvent.loaded / progressEvent.total;
                log(`Upload progress: ${progress.value * 100}%`, progressEvent);
            })
                .then(file => emitChange(file.internalUri))
                .catch(e => error.value = e?.response?.data?.message ?? String(e))
                .finally(() => {
                loading.value = false;
                progress.value = 0;
            });
            // TODO delete previously uploaded but unsaved?
            // TODO prevent form submit during upload
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (showFileLink.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(FileLink, { uri: __props.data }, null, 8, ["uri"]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(emitChange)(null)), ["prevent"])),
                            class: "file__clear"
                        }, [
                            _createVNode(Icon, { name: "times-circle" })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (loading.value)
                    ? (_openBlock(), _createBlock(ProgressBar, {
                        key: 1,
                        progress: progress.value
                    }, null, 8, ["progress"]))
                    : _createCommentVNode("", true),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (!loading.value)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 2,
                        ref_key: "root",
                        ref: root,
                        onChange: onChange,
                        onFocus: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                        onBlur: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                        type: "file",
                        id: __props.fieldId,
                        disabled: _unref(fieldOptions).disabled ?? undefined,
                        accept: acceptedFiles.value,
                        required: _unref(fieldOptions).required ?? undefined,
                        multiple: _unref(fieldOptions).multiple ?? undefined
                    }, null, 40, _hoisted_3))
                    : _createCommentVNode("", true),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
